<template>
  <div id="app">
    <router-view />
    <!-- <iframe
      :src="fopSrc"
      style="display: none;"
    /> -->
  </div>
</template>

<script>
import { SappModule } from '@/store/modules/app'
import PerfectScrollbar from 'perfect-scrollbar'
import { Loader } from '@googlemaps/js-api-loader'
import API from '@/api'
import Cookies from 'js-cookie'
// import './test.js'

export default {
  name: 'App',
  data() {
    return {
      createdCsat: false,
      fopSrc: process.env.VUE_APP_BOOKING_FOP_PLACE_ORDERS_FOR_CUSTOMERS
    }
  },
  computed: {
    dirType() {
      return SappModule.language === 'ar' ? 'rtl' : 'ltr'
    }
  },
  watch: {
    '$store.state.user.fullname': {
      handler(val) {
        console.log('拿到user', val)
        if (val && !this.createdCsat) {
          this.createdCsat = true
          setTimeout(() => {
            this.createCsat()
          }, 10000)
        }
      },
      immediate: true
    }
  },
  created() {
    window.system = 'iTMS'
    window.site = 'SG'
    const isEU = process.env.NODE_ENV === 'holl'
    if (isEU) {
      window.site = 'NL'
    }
    // this.loadSpyScript('https://storage.jd.co.th/imp/jdl-spy.min.js')
    this.loadScript('https://storage.jd.co.th/fop-source-static/sc-sdk-1.0-0701.js')
    this.loadScript('https://storage.jd.co.th/imp/ux-scene-research-itms.umd.js')
    const loader = new Loader({
      apiKey: process.env.VUE_APP_GOOGLE_MSP_KEY,
      version: 'weekly',
      language: SappModule.language || 'en', // 将 'ar' 改为 'en' 或 'zh-CN' 或 'zh-TW' 以更改语言,
      mapId: '1ea87b22125a4812' // Map ID is required for advanced markers.
    })
    loader.load().then(() => {
      console.log('google map 加载完毕')
      window.googleMapLoaded = true
    })
    // this.loader = loader;
  },
  mounted() {
    // const scrollContainer = document.body
    // console.log('scrollContainer', { scrollContainer })
    // // 初始化 PerfectScrollbar
    // this.ps = new PerfectScrollbar(scrollContainer)

  },
  methods: {
    createCsat(fullname) {
      try {
        const loginType = Cookies.get('itms.login.type') || 1
        const lang = Cookies.get('language') || 'zh_CN'
        const envArr = ['production', 'yf', 'gray', 'holl', 'hollgray']
        const devEnvArr = ['yf1', 'hollpre']
        console.log('csat参数', {
          prefix: process.env.NODE_ENV === 'yf1' ? 'https://uat-csat.jd.com/' : 'https://csat.jd.com',
          systemCode: 'iTMS',
          userType: loginType === 1 || loginType === '1' ? 1 : 3, // 3 B 账号
          routerType: 'history',
          language: lang,
          languages: {
            ar_SA: {
              writingMode: 'rl' // 书写方向
            }
          },
          headers: {
            pin: fullname,
            'Lop-Dn': loginType !== 1 && loginType !== '1' ? 'b.csat.jdl.com' : 'erp.csat.jdl.com' // process.env.NODE_ENV === 'yf1' ? 'erp.csat.jdl.com' // 'erp.csat.jdl.com'外网ERP // b.csat.jdl.com  B账号// 'erp.csat.local.com' 内网ERP
          }
        })
        window.JD_CSAT({
          prefix: process.env.NODE_ENV === 'yf1' ? 'https://uat-csat.jd.com/' : 'https://csat.jd.com',
          systemCode: 'iTMS',
          userType: loginType === 1 || loginType === '1' ? 1 : 3, // 3 B 账号
          routerType: 'history',
          language: lang,
          languages: {
            ar_SA: {
              writingMode: 'rl' // 书写方向
            }
          },
          headers: {
            pin: fullname,
            'Lop-Dn': loginType !== 1 && loginType !== '1' ? 'b.csat.jdl.com' : 'erp.csat.jdl.com' // process.env.NODE_ENV === 'yf1' ? 'erp.csat.jdl.com' // 'erp.csat.jdl.com'外网ERP // b.csat.jdl.com  B账号// 'erp.csat.local.com' 内网ERP
          }
        }).then((instance) => {
          console.log('初始化CSAT成功')
          window.__JD_CSAT = instance
        })
      } catch (error) {
        console.log('初始化CSAT失败', error)
      }
    },
    loadSpyScript(url) {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url

      script.onload = () => {
        try {
          // this.initPageSpy()
        } catch (error) {

        }
      }

      script.onerror = function() {
        console.error('Error loading script:', url)
      }

      document.body.appendChild(script)
    },
    loadScript(url) {
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = url
      document.body.appendChild(script)
      script.onload = () => {
        try {
          window.configUrlFilters({
            exact: [
              '/api/spm/getUserMenuResourceList', // 精确匹配菜单接口
              '/api/user/info' // 精确匹配用户信息接口
            ],
            contains: [
              '/ducc/', // 过滤所有公共接口
              '/csat/',
              '/getUserUnreadMessages',
              '/countUserUnreadMessage',
              '/pulsar-meta/metaDataAddInner'
            ]
          })
        } catch (error) {

        }
      }
    },
    async initPageSpy() {
      const res = await API.getPageSpyWhiteList()
      let whiteList = []
      console.log('getPageSpyWhiteList', res)
      if (res.data && res.data.value) {
        const json = JSON.parse(res.data.value)
        whiteList = json.pinAndConfig
      }
      const currentPinAndConfig = whiteList.find(item => item.pin === localStorage.getItem('erp'))
      if (window.JDLSpy && currentPinAndConfig) {
        const spy = new window.JDLSpy({
          project: 'iTMS',
          offline: currentPinAndConfig.offline,
          title: localStorage.getItem('erp')
        })
        spy.init()
        window.jdlSPyObj = spy
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/index.scss';
@import url('https://storage.360buyimg.com/quark-icon/icons/font_163309oiZ6OVQNUZnH.css');
@import url('https://s1-relay.360buyimg.com/relay/c/iconfont/7/font_397B1xPjaUekjna.css');
.el-select-dropdown__wrap{
  margin-bottom: -4px !important;
}
html #app, micro-app[name=print-manage] micro-app-body #app{
  text-align: left !important;
}
.first-level-hide{
  background-color: unset !important;
  &:hover{
    background-color: #ffffff !important;
  }
  .first-level-menu{
    .sidebar-icon{
      width: 48px;
      height: 40px;
      border-radius: 8px;
      &:hover{
        background-color: #F5F5F6;
      }
    }

    span{
      display: none;
    }

  }
}
.is-active{
  &.first-level-hide{
    .sidebar-icon{
      width: 48px;
      height: 40px;
      border-radius: 8px;
      background-color: rgba(72,127,247,.1)!important;
      &:hover{
        background-color:  #487ff71a;
      }
    }

    span{
      display: none;
    }

  }
}
.hideSidebar{
  .submenu-title-noDropdown{
    background-color: #ffffff !important;
    &:hover{
      background-color: #ffffff !important;
    }
    span{
      display: none !important;
    }
  }
}
.el-submenu__title{
  div{
    span{
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
      width: calc(100% - 20px);
    }
    .common-num, .common-selected-num{
      width: unset !important;
    }
  }
  .el-icon-arrow-down{
    &::before{
      width: 16px;
      height: 16px;
      content: '';
      display: inline-block;
      background-image: url('~@/assets/img/header/menu-down.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
.main-common{
  input{
    &::placeholder{
      color: #868D9F !important;
    }
  }
  .el-input__inner{
    color: #23252B;
    background: rgba(245,245,246,1);
    border-radius: 8px !important;
  }
}

#app {
  overflow: hidden;
  height: 100%;
}
.theme-blue .sidebar-container .nest-menu .el-submenu > .el-submenu__title:hover, .theme-blue .sidebar-container .nest-menu .el-submenu > .el-submenu__title p:hover, .theme-blue .sidebar-container .el-submenu .el-menu-item:hover{
  background-color: #F5F5F6 !important;
}
.itms-menu-item-list .el-submenu__title span{
  font-weight: 500;
}

.app-export-dialog-warntxt {
  color: #333;
  font-size: 16px;
  padding-bottom: 5px;
}

.app-export-dialog-result {
  color: #666;
  font-size: 14px;
  text-align: center;
  .app-export-dialog-result-item {
    margin-right: 8px;
    .app-export-dialog-result-item-num {
      color: #26A872;
      margin: 2px;
    }
  }
}
body{
  height: 100% !important;
  overflow: hidden; // 添加perfectscrollbar 替换原生滚动条，节省空间
  position: relative;
}
</style>
